<template>
  <section>
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="py-12 md:py-20 border-t border-gray-200 lg:border-0 lg:pt-0">
        <!-- Section header -->
        <div class="max-w-3xl mx-auto text-center pb-8 md:pb-12">
          <h2 class="h2 mb-4">ご利用料金</h2>
        </div>

        <!-- Items -->
        <div
          class="max-w-sm mx-auto grid gap-8 md:grid-cols-2 lg:gap-16 items-start md:max-w-2xl lg:max-w-none"
          data-aos-id-blocks
        >
          <!-- 1st item -->
          <div class="relative flex flex-col items-center" data-aos="fade-up" data-aos-anchor="[data-aos-id-blocks]">
            <h4 class="h4 mb-2">初月（体験価格）</h4>
            <p class="h2 text-theme-100 text-center">
              500円 / 月
            </p>
          </div>

          <!-- 2nd item -->
          <div
            class="relative flex flex-col items-center"
            data-aos="fade-up"
            data-aos-delay="100"
            data-aos-anchor="[data-aos-id-blocks]"
          >
            <h4 class="h4 mb-2">２ヶ月目以降</h4>
            <p class="h2 text-theme-100 text-center">
              3,980円 / 月
            </p>
          </div>
        </div>
        <div class="max-w-3xl mx-auto mt-12 text-center pb-12 md:pb-20">
          <p class="text-lg text-gray-600">
            ※売上の1割を社会貢献としての寄付金に当てさせて頂きます。今後、ここの部分もできる限り明瞭に皆様にお伝えしていく予定です。
            健康になることが社会貢献に繋がる仕組みを作っていきます。
          </p>
        </div>
        <div class="max-w-3xl mx-auto mt-12 text-center">
          <a
            class="mx-auto flex mt-12 p-4 bg-theme-100 hover:bg-theme-200 button"
            v-scroll-to="'#cta'"
            data-aos="fade-up"
            data-aos-anchor="[data-aos-id-blocks]"
            data-aos-delay="200"
          >
            <span class="block w-full font-bold text-center text-white">お申し込みはこちら</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PriceKaradaSupport",
}
</script>
